module.exports = __webpack_public_path__ + "img/奖章3级@2x.e7c20e33.png";